//
// Smooth Scroll Polyfill
//

import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
